import { FormField } from "@/components/elements/FormField";
import { InnerBox } from "@/components/elements/InnerBox";
import { Textarea } from "@/components/elements/Textarea";
import { TTalentForm } from "@/features/talent/types/talentForm";
import { divider, black } from "@/theme/colors";
import { FCC } from "@/types/common";
import { Stack, Box, Typography, Grid } from "@mui/material";
import { useFormContext } from "react-hook-form";

type TalentFormFamilyInfoProps = {};

export const TalentFormFamilyInfo: FCC<TalentFormFamilyInfoProps> = () => {
  const methods = useFormContext<TTalentForm>();
  const { control } = methods;

  return (
    <InnerBox mt={4} p={3} mb={4} showDivider={false} borderColor={divider.high} bordered={true}>
      <Stack direction="row" alignItems="center" spacing={2}>
        <Box flex={1}>
          <Typography variant="head20Bold" color={black[30]}>
            家族構成
          </Typography>
        </Box>
      </Stack>

      <Stack mt={2}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <FormField control={control} name="familyInformation" noLabel>
              <Textarea placeholder="入力してください" />
            </FormField>
          </Grid>
        </Grid>
      </Stack>
    </InnerBox>
  );
};
